import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  footer?: React.ReactNode;
  headerAction?: React.ReactNode;
}

export const Card = ({ children, className = '', title, description, footer, headerAction }: CardProps) => {
  return (
    <div className={`bg-white rounded-2xl border border-slate-200 shadow-sm ${className}`}>
      {(title || description || headerAction) && (
        <div className="px-5 py-4 border-b border-slate-50 rounded-t-2xl">
          <div className="flex items-center justify-between gap-4">
            <div>
              {title && <h3 className="text-xs font-bold text-slate-900 tracking-tight">{title}</h3>}
              {description && <p className="text-sm text-slate-500 mt-0.5 font-medium">{description}</p>}
            </div>
            {headerAction && <div className="shrink-0">{headerAction}</div>}
          </div>
        </div>
      )}
      <div className="px-5 py-5">
        {children}
      </div>
      {footer && (
        <div className="px-5 py-4 bg-slate-50/50 border-t border-slate-100 rounded-b-2xl">
          {footer}
        </div>
      )}
    </div>
  );
};



